import styled from 'styled-components';
import { Palette } from '../utils';

export const ScrollViewportShell = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const SCROLL_FADE_HEIGHT_PX = 72;
export const SCROLL_FADE_CLEARANCE_PX = 40;
export const SCROLL_PROGRESS_TRACK_HEIGHT_PX = 8;
export const SCROLL_FOOTER_CHROME_MARGIN_PX = 24;

export const ScrollFadeOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${SCROLL_PROGRESS_TRACK_HEIGHT_PX}px;
  height: ${SCROLL_FADE_HEIGHT_PX}px;
  pointer-events: none;
  z-index: 1;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    ${Palette.WHITE} 100%
  );
`;

export const ScrollFadeClearance = styled.div`
  height: ${SCROLL_FADE_CLEARANCE_PX}px;
  flex-shrink: 0;
  width: 100%;
`;

export const ScrollFooterColumn = styled.div`
  align-self: stretch;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
`;

export const ScrollProgressTrack = styled.div`
  align-self: stretch;
  position: relative;
  height: ${SCROLL_PROGRESS_TRACK_HEIGHT_PX}px;
  border-radius: 80px;
  overflow: hidden;
  background: ${Palette.GREY_100};
`;

export const ScrollProgressFill = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${({ $progress }) => `${Math.min(100, Math.max(0, $progress * 100))}%`};
  border-radius: 8px;
  background: ${Palette.OCEANIC};
  transition: width 0.1s ease-out;
`;

export const ScrollFooterActions = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ScrollFooterActionsStacked = styled.div`
  align-self: stretch;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 8px;

  & > * {
    width: 100%;
    margin: 0 !important;
  }
`;
